import React from 'react';
import { ChannelMap } from '../../../../../redux/groups/api/group.model';
import ChannelSensor from './ChannelSensor';
import ChannelEvent from './ChannelEvent';
import ChannelAction from './ChannelAction';
import ChannelSetPoint from './ChannelSetPoint';
import ChannelVirtualSuperHeat from './ChannelVirtualSuperHeat';
import { ChannelVirtualSuperHeatProps } from './hooks/useChannelVirtualSuperHeat';

export interface ChannelConnectionProps {
  channel: (ChannelMap & { name?: string }) | null;
  onClick?: () => void;
  selected?: boolean;
}
function ChannelConnection(
  props: ChannelConnectionProps & ChannelVirtualSuperHeatProps
) {
  const { channel } = props;
  const { channelType } = channel ?? {};

  switch (channelType) {
    case 'sensordata':
      return <ChannelSensor {...props} />;
    case 'action':
      return <ChannelAction {...props} />;
    case 'event':
      return <ChannelEvent {...props} />;
    case 'setpoint':
      return <ChannelSetPoint {...props} />;
    case 'virtual_superheat':
      return <ChannelVirtualSuperHeat {...props} />;
    default:
      return <p> not supported</p>;
  }
}
export default ChannelConnection;
